import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { api, img, list, money } from "@/lib/api";
import { Reveal, Eyebrow } from "./Reveal";

export const SoldWall = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/products/sold").then((r) => setItems(list(r))).catch(() => setItems([]));
  }, []);
  if (!items.length) return null;
  return (
    <section data-testid="sold-wall" className="border-y border-[#281245] bg-[#0b0514]">
      <div className="mx-auto max-w-[1400px] px-5 py-28 md:px-10 md:py-36">
        <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <Eyebrow>Recently sold</Eyebrow>
            <h2 className="font-display mt-5 text-5xl leading-[0.95] text-[#f3eefc] md:text-6xl">Gone, <span className="italic text-[#d8b4fe]">just like that.</span></h2>
          </div>
          <p className="max-w-xs text-sm text-[#cbbbe6]">Gone to a happy home.</p>
        </Reveal>
        <div className="grid grid-cols-2 gap-x-4 gap-y-12 md:gap-x-6 lg:grid-cols-4">
          {items.map((p, i) => (
            <Reveal key={p.id} delay={(i % 4) * 0.06}>
              <Link to={`/item/${p.id}`} data-testid={`sold-card-${p.id}`} className="group relative block">
                <div className="chamfer relative aspect-[4/5] overflow-hidden bg-[#110720]">
                  <img src={img(p.images?.[0])} alt={p.title} loading="lazy" className="h-full w-full object-cover grayscale transition-transform duration-[1.2s] group-hover:scale-105" />
                  <div className="absolute inset-0 bg-[#07030c]/40" />
                  <span className="font-mono-j absolute left-4 top-4 rounded-full border border-emerald-400/60 bg-[#07030c]/70 px-2.5 py-1 text-[11px] uppercase tracking-widest text-emerald-300 backdrop-blur">Sold</span>
                </div>
                <div className="mt-4">
                  <div className="flex items-baseline justify-between gap-3">
                    <p className="truncate text-[15px] text-[#cbbbe6]">{p.title}</p>
                    <p className="font-mono-j shrink-0 text-base text-[#cbbbe6]">{money(p.price)}</p>
                  </div>
                  {p.sold_at ? <p className="font-mono-j mt-1 text-xs text-[#a78bce]" data-testid={`sold-date-${p.id}`}>Sold {new Date(p.sold_at).toLocaleDateString("en-CA", { month: "short", day: "numeric" })}</p> : null}
                  {p.review_count > 0 && (
                    <p className="font-mono-j mt-1 flex items-center gap-1 text-xs text-[#a78bce]">
                      <Star className="h-3 w-3 fill-[#d8b4fe] text-[#d8b4fe]" /> {p.review_avg} ({p.review_count})
                    </p>
                  )}
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
